/*!
 * @Author: Cascade
 * @Date: 2026-02-02
 * @Introduction: OIDC 配置文件
 * @Description: 闻客信息 IDaaS 平台 OIDC 配置
 */

/**
 * OIDC 配置接口
 */
export interface IOIDCConfig {
    clientId: string           // 客户端 ID（公开信息）
    authorizeEndpoint: string  // 授权端点
    redirectUri: string        // 回调地址
    responseType: string       // 响应类型
    scope: string              // 请求的权限范围
}

/**
 * OIDC 配置
 * 注意：此处仅包含公开信息，不包含 Client Secret
 */
const oidcConfig: IOIDCConfig = {
    // 客户端 ID（公开信息，由 IDP 分配）
    clientId: 'client_1770006790010',
    
    // 授权端点
    authorizeEndpoint: 'https://idaas.waykey.net/oidc/client_1770006790010/authorize',
    
    // 回调地址（根据环境动态生成）
    redirectUri: `${window.location.origin}/callback`,
    
    // 响应类型：使用授权码模式
    responseType: 'code',
    
    // 请求的权限范围
    scope: 'openid profile email'
}

export default oidcConfig
